<p-dialog
  [closable]="false"
  [draggable]="false"
  [modal]="true"
  [resizable]="false"
  [visible]="true"
>
  <ng-template #header>
    <header class="confirm-dialog">
      <h4>Inland details</h4>
    </header>
    <a
      role="button"
      tabindex="0"
      (click)="close()"
      (keyup.enter)="close()"
      aria-hidden="true"
      class="p-dialog-titlebar-icon ui-dialog-titlebar-close"
    >
      <span class="pi pi-times"></span>
    </a>
  </ng-template>

  <div class="row">
    @if (originCountry) {
      <div class="col-md-12">
        <span class="form-control-label">Origin:</span>
        <app-maersk-location-select
          [country]="originCountry"
          (locationChange)="
            originCountry = $event.country; originLocation = $event.location
          "
        ></app-maersk-location-select>
      </div>
    }

    @if (destinationCountry) {
      <div class="col-md-12">
        <span class="form-control-label">Destination:</span>
        <app-maersk-location-select
          [country]="destinationCountry"
          (locationChange)="
            destinationCountry = $event.country;
            destinationLocation = $event.location
          "
        ></app-maersk-location-select>
      </div>
    }
  </div>

  <div class="activity-footer">
    <button pButton (click)="save()">Get rates</button>
    <button pButton severity="secondary" (click)="close()">Cancel</button>
  </div>
</p-dialog>
